import { switchAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
    createMultiStyleConfigHelpers(switchAnatomy.keys)

const invertedStyle = definePartsStyle((props: any) => ({
    track: {
        bg: 'gray.300',
        _checked: {
            bg: 'white',
        },
    },
    thumb: {
        bg: 'white',
        _checked: {
            bg: `${props.colorScheme}.500`,
        },
    },
}))

export const Switch = defineMultiStyleConfig({
    variants: {
        inverted: invertedStyle,
    },
})
